<template>
  <div v-if="showFlag" class="spinBox">
    <spinner type="ios"></spinner>
  </div>
  <ul v-else>
    <!--<li v-if="livingList.length" class="live_3PxBorder">-->
    <!--<div class="living_box live_1PxBorder" v-for="(item,index) in livingCourse"-->
    <!--:key="item.id" @click="jump(item)">-->
    <!--<img class="live_photo" :src="item.wx_head_photo" alt="">-->
    <!--<div class="right">-->
    <!--<p class="live_user">-->
    <!--<span class="times" v-if="item.is_liveing == 0">{{item.live_start_time | time}}</span>-->
    <!--<img v-else src="//cdn.yxvzb.com/wechatfolder/image/liveIcon_03.png" alt="">-->
    <!--<span>{{item.full_name}}</span>-->
    <!--<span>|</span>-->
    <!--<span>缺少医院</span>-->
    <!--<span>{{item.DUTIES}}</span></p>-->
    <!--<p class="live_title">{{item.course_name}}</p>-->
    <!--</div>-->
    <!--</div>-->

    <!--</li>-->
    <li
      class="living"
      v-if="list.length"
      v-for="(item, index) in formatListArr"
      :key="item.id"
      @click="jump(item)"
    >
      <div class="living_box">
        <img class="live_photo" :src="item.coverPicUrl" alt="" />
        <div class="right">
          <div class="live_user">
            <div class="full_name">
              <div class="info_box">
                <span>{{ item.userName }}</span>
                <span class="line">|</span>
                <span class="top_hos">{{ item.duties }}</span>
              </div>
              <span class="times">{{ item.liveStartTime | time }}</span>
              <img
                class="is-living"
                v-if="item.isLiving == 1"
                src="http://cdn.yxvzb.com/newWechat/image/live_icon@2x.png"
                alt=""
              />
              <img
                class="is-living"
                v-else-if="item.isLiving == 0"
                src="http://cdn.yxvzb.com/newWechat/image/beforelive@2x.png"
                alt=""
              />
              <img
                class="is-living"
                v-else-if="item.isLiving == 2"
                src="http://cdn.yxvzb.com/newWechat/image/end_icon@2x.png"
                alt=""
              />
            </div>
            <p class="live_title">{{ item.hospitalName }}</p>
          </div>
          <!-- <p class="live_title">{{item.course_name}}</p> -->
        </div>
      </div>
    </li>
    <li class="living_end" v-if="!list || !list.length">
      <div class="living_end" style="font-size: .37rem;">
        <span style="margin: auto">
          今日直播已经结束,点击
          <router-link to="/liveTrailer" tag="b" style="color: #027CFA">
            查看更多
          </router-link>
        </span>
      </div>
    </li>
  </ul>
</template>
<script>
// TODO: vux
import { dateFormat, Spinner } from 'vux';
export default {
  name: '',
  props: {
    livingCourse: {
      type: Array,
      default: function() {
        return [
          {
            userName: '', //医师姓名
            courseName: '', //课程名称
            is_liveing: '', //是否直播中
            duties: '', //职位名称
            headPhoto: '', //医师头像
            id: '', //课程ID
            liveStartTime: '', //直播开始时间
            liveEndTime: '' //直播结束时间
          }
        ];
      }
    }
  },
  data() {
    return {
      inter: null,
      livingList: [1, 2, 3],
      list: [],
      formatListArr: [],
      showFlag: true
    };
  },
  methods: {
    jump(item) {
      let wxUserInfo = this.$api.getStorage('wxUserInfo');

      sa.track(
        'liveItem_click',
        {
          pageUrl: location.href,
          liveClassId: item.id,
          liveClassName: item.course_name,
          client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
          web_edition: 2
        },
        function() {}
      );

      this.$router.push({ name: 'liveDetail', params: { id: item.id } });
    },
    formatList() {
      this.list.filter((item, index) => {
        if (
          new Date().getTime() > item.liveStartTime &&
          new Date().getTime() < item.liveEndTime
        ) {
          this.$set(item, 'isLiving', 1);
        } else if (
          new Date().getTime() < item.liveStartTime &&
          item.liveStartTime - new Date().getTime() <= 6000000
        ) {
          this.$set(item, 'isLiving', 0);
        } else if (new Date().getTime() < item.liveStartTime) {
          //
        } else {
          this.$set(item, 'isLiving', 2);
        }
      });
      this.formatListArr = this.list;
      // console.log(this.list);
    }
  },
  computed: {},
  components: {
    Spinner
  },
  watch: {
    livingCourse(n, o) {
      this.showFlag = false;
      if (n.length > 0) {
        this.list = n;
        this.formatList();
        this.inter = setInterval(() => {
          this.formatList();
        }, 10 * 1000);
      }
    }
  },
  created() {
    this.livingList.splice(0, 1);
  },
  beforeDestroy() {
    clearInterval(this.inter);
  },
  filters: {
    time: function(val) {
      return dateFormat(val, 'HH:mm');
    }
  }
};
</script>
<style lang="less" scoped>
.spinBox {
  width: 0.8rem;
  height: 0.8rem;
  margin: auto;
}
.hiden() {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.line {
  margin: 0 0.01rem;
}

.top_right {
  display: flex;
}

.top_hos {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*width: 8.5rem;*/
  //  .hiden
}

ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .living {
    width: 4.51rem;
    border-radius: 0.11rem;
    .living_box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      .right {
        width: 100%;
        padding: 0 0.19rem;
      }
    }
    .live_photo {
      width: 100%;
      height: 2.53rem;
      border-radius: 0.08rem;
      /*flex: 1;*/
    }
    .is-living {
      position: absolute;
      top: 7%;
      left: 7%;
    }
    .full_name {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .info_box {
        width: 80%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    // div {
    //   line-height: 1.4;

    // }
    /*
      需要和产品确定 昵称医院宽
      */
    .live_user {
      margin: 0.16rem 0 0.27rem 0;
      font-size: 0.32rem;
      color: #999;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      /*.hiden*/
      img {
        width: 0.96rem;
      }
      .times {
        /*margin-right: .2rem;*/
        width: 0.96rem;
        text-align: left;
      }
    }
    .live_title {
      width: 90%;
      font-size: 0.32rem;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .living_end {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 1.6rem;
  }
}
</style>
